package com.mps.asc_app.data.user

data class MemberProfile(
    val uid: String,
    val email: String,
    val firstName: String,
    val lastName: String,
    val memberNumber: String,
    val phone: String,
    val addressText: String,
    val placeId: String?,
    val sports: List<String>,
    val status: UserStatus,
    val isAdmin: Boolean,
    val isTrainer: Boolean,
    val trainerAssignments: List<String>,
    val manuallyChecked: Boolean = false,
)

